import React from "react"
import { Button } from "antd"
import humbleicon from "../../../assets/images/humbleicons_ai.png"

const AIEnhancedTextDisplay = ({ enhancedText, onApplyEnhancement, isRecording = false }) => {
  console.log("🔍 AIEnhancedTextDisplay Debug:", { enhancedText })

  if (!enhancedText) return null

  return (
    <div className="indicator-ai-response-container">
      <div className="indicator-ai-response-box-program-matrix">
        <div className="indicator-ai-response-header">
          <img
            src={humbleicon}
            alt="AI"
            className="indicator-ai-response-icon"
          />
          AI Enhanced Text
        </div>
        <div className="indicator-ai-response-text">
          {enhancedText.replace(/^"|"$/g, "")}
        </div>
        <Button
          onClick={onApplyEnhancement}
          className="indicator-ai-apply-btn-enhancement-implementation-actual-programmatrix"
          disabled={isRecording}
        >
          Apply Enhancement
        </Button>
      </div>
    </div>
  )
}

export default React.memo(AIEnhancedTextDisplay)
